import { StatesService_collCalcStateServiceGetGetCcStateStatus } from '@festina/collcalc-general-types/collcalc/hooks/StatesService_collCalcStateServiceGetGetCcStateStatus'

export const useFetchCollCalcStatusNoSuspense =
  StatesService_collCalcStateServiceGetGetCcStateStatus.useQuery
